// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"5d129e86","417":"a1ba4088","538":"55ff08ee","787":"349b0e60","852":"c1ca8327"}[chunkId] + ".chunk.js";
};